import { State } from "../state";
import { Request } from "@/network/request";
// import Swal from "sweetalert2";
import i18n from "../../i18n";
import toast from "../../plugins/toast";

export default class agegroup {
  token = $cookies.get("token");
  tableData = {
    data: [],
    headers: {
      id: {
        name: "id",
        keys: ["id"],
      },
      name: {
        name: "name",
        keys: ["name"],
      },
      description: {
        name: "description",
        keys: ["description"],
      },
    },
    meta: {
      total: 1,
      per_page: 1,
      current_page: 1,
    },
  };

  getAgeState = new State();
  postAgeState = new State();
  editAgeState = new State();
  deleteAgeState = new State();

  async getAgeGroup(params) {
    let request = new Request({
      method: "get",
      endpoint: `/age_group`,
      params: params,
      token: this.token,
    });

    await this.getAgeState.trigger(
      async () => {
        return await request.send();
      },
      {
        onSuccess: (value) => {
          this.tableData.data = value.ageGroups;
          this.tableData.meta = value.meta;
        },
        onError: (error) => {
          console.log(error);
        },
      }
    );
  }
  postAgeGroup(payload) {
    let request = new Request({
      method: "post",
      endpoint: `/age_group`,
      data: payload,
      token: this.token,
    });

    this.postAgeState.trigger(
      async () => {
        return await request.send();
      },
      {
        onSuccess: (value) => {
          this.getAgeGroup();
          toast(
            i18n.t("create success"),
            { timeout: 4000, rtl: true },
            "sucess"
          );
        },
        onError: (error) => {
          console.log(error);
        },
      }
    );
  }
  editAgeGroup(payload, id) {
    let request = new Request({
      method: "put",
      endpoint: `/age_group/${id}`,
      data: payload,
      token: this.token,
    });

    this.editAgeState.trigger(
      async () => {
        return await request.send();
      },
      {
        onSuccess: (value) => {
          this.getAgeGroup();
        },
        onError: (error) => {
          console.log(error);
        },
      }
    );
  }
  deleteAgeGroup(id) {
    let request = new Request({
      method: "delete",
      endpoint: `/age_group/${id}`,
      token: this.token,
    });

    this.deleteAgeState.trigger(
      async () => {
        return await request.send();
      },
      {
        onSuccess: (value) => {
          this.getAgeGroup();
        },
        onError: (error) => {
          console.log(error);
        },
      }
    );
  }
}

export const ageGroup = new agegroup();
